import React, { PureComponent } from "react";
import { Button } from "@material-ui/core";

interface Props {
  expandText?: string;
  shrinkText?: string;
  fixedVisibleCount?: number;
  children: any;
}

interface State {
  isExpanded: boolean;
}

export class ExpandItems extends PureComponent<Props, State> {
  state: State = {
    isExpanded: false,
  };
  static defaultProps = {
    shrinkText: "View less",
    fixedVisibleCount: 2,
  };
  toggleExpand = () => {
    this.setState((prevState) => ({
      ...prevState,
      isExpanded: !prevState.isExpanded,
    }));
  };
  getDefaultExpandText = () => {
    const { fixedVisibleCount, children } = this.props;
    const childrenCount = React.Children.count(children);
    const diff = childrenCount - (fixedVisibleCount || 0);
    return diff > 0 ? `+${diff} more` : "";
  };

  getVisibleChildren = () => {
    const { children, fixedVisibleCount } = this.props;
    const { isExpanded } = this.state;
    if (isExpanded) {
      return children;
    }
    return React.Children.toArray(children).slice(0, fixedVisibleCount);
  };
  render() {
    const {
      expandText = this.getDefaultExpandText(),
      shrinkText,
      children,
      fixedVisibleCount = 0,
    } = this.props;
    const { isExpanded } = this.state;
    const totalChildrenCount = React.Children.count(children);
    const visibleChildren = this.getVisibleChildren();
    return (
      <>
        {visibleChildren}
        {totalChildrenCount > fixedVisibleCount && (
          <Button
            color="primary"
            style={{ cursor: "pointer" }}
            onClick={this.toggleExpand}
          >
            {!isExpanded ? expandText : shrinkText}
          </Button>
        )}
      </>
    );
  }
}
